import type { AuthState } from "@nasam/kernel";

export type AuthGuardResult =
  | { readonly allowed: true }
  | { readonly allowed: false; readonly redirectTo: string };

export function resolveAuthGuard(
  state: Pick<AuthState, "initialized" | "accessToken" | "user">,
): AuthGuardResult {
  if (!state.initialized)
    return { allowed: false, redirectTo: "/auth/loading" };
  if (state.accessToken === null || state.user === null) {
    return { allowed: false, redirectTo: "/auth/login" };
  }
  return { allowed: true };
}

export function resolveGuestGuard(
  state: Pick<AuthState, "initialized" | "accessToken" | "user">,
): AuthGuardResult {
  if (!state.initialized)
    return { allowed: false, redirectTo: "/auth/loading" };
  if (state.accessToken !== null && state.user !== null) {
    return { allowed: false, redirectTo: "/" };
  }
  return { allowed: true };
}
